import { ElMessageBox } from 'element-plus';

const DEFAULT_MESSAGE = '请先登录后继续操作';
const DEFAULT_TITLE = '需要登录';
const LOGIN_ROUTE_PATH = '/login';

let dialogVisible = false;

const LOGIN_REQUIRED_REGEX = /(请先登?录|还未登录|还没有登录)/;

const getCurrentPath = (route) => {
  const fullPath = route && typeof route.fullPath === 'string'
    ? route.fullPath
    : route && typeof route.path === 'string'
      ? route.path
      : '/';
  if (!fullPath.startsWith('/')) {
    return '/';
  }
  if (fullPath.startsWith('/login') || fullPath.startsWith('/register')) {
    return '/';
  }
  return fullPath;
};

const getLoginTarget = (router) => {
  const currentRoute = router && router.currentRoute ? router.currentRoute.value : null;
  const redirectPath = getCurrentPath(currentRoute);
  if (redirectPath === '/') {
    return { path: LOGIN_ROUTE_PATH };
  }
  return {
    path: LOGIN_ROUTE_PATH,
    query: {
      redirect: redirectPath,
    },
  };
};

const extractText = (payload) => {
  if (typeof payload === 'string') {
    return payload;
  }
  if (!payload || typeof payload !== 'object') {
    return '';
  }
  return payload.content || payload.message || payload.desc || '';
};

export const isLoginRequiredMessage = (payload) => {
  const text = extractText(payload);
  return typeof text === 'string' && LOGIN_REQUIRED_REGEX.test(text);
};

export const showLoginRequiredPrompt = (vmOrRouter, message = DEFAULT_MESSAGE, title = DEFAULT_TITLE) => {
  const router = vmOrRouter && vmOrRouter.push
    ? vmOrRouter
    : vmOrRouter && vmOrRouter.$router
      ? vmOrRouter.$router
      : null;
  if (dialogVisible) {
    return Promise.resolve(false);
  }
  dialogVisible = true;
  return ElMessageBox.confirm(message || DEFAULT_MESSAGE, title, {
    type: 'warning',
    confirmButtonText: '去登录',
    cancelButtonText: '取消',
    distinguishCancelAndClose: true,
  }).then(() => {
    if (router) {
      router.push(getLoginTarget(router));
    }
    return true;
  }).catch(() => false)
    .finally(() => {
      dialogVisible = false;
    });
};

const patchMessageMethod = (api, methodName, router) => {
  if (!api || typeof api[methodName] !== 'function') {
    return;
  }
  const original = api[methodName].bind(api);
  api[methodName] = (payload, ...args) => {
    if (isLoginRequiredMessage(payload)) {
      showLoginRequiredPrompt(router, extractText(payload));
      return;
    }
    return original(payload, ...args);
  };
};

export const installLoginRequiredPromptInterceptor = (app, router) => {
  if (!app || !app.config || !app.config.globalProperties) {
    return;
  }
  const gp = app.config.globalProperties;
  patchMessageMethod(gp.$Message, 'warning', router);
  patchMessageMethod(gp.$Message, 'error', router);
  patchMessageMethod(gp.$Notice, 'warning', router);
  patchMessageMethod(gp.$Notice, 'error', router);
};
